import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DeletedBaseType, SubjectCategory, SubjectType} from '@npck/af-frontend-api';

export const MAX_DESCRIPTION_LENGTH = 2000;
export const SUBJECT_DELETED_BASED_FILTER = ['subject', 'all'];

@Component({
    templateUrl: './delete-subject-category-dialog.component.html',
    standalone: false,
})
export class DeleteSubjectCategoryDialogComponent {
    form: FormGroup<DeleteSubjectCategoryForm>;
    maxDescriptionLength = MAX_DESCRIPTION_LENGTH;
    deletedBasedFilter = SUBJECT_DELETED_BASED_FILTER;
    SubjectType = SubjectType;
    DeletedBaseType = DeletedBaseType;

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: DeleteSubjectCategoryDialogData,
        public dialogRef: MatDialogRef<DeleteSubjectCategoryDialogComponent, DeleteSubjectCategoryDialogResult>,
        private formBuilder: FormBuilder,
    ) {
        this.form = this.formBuilder.group<DeleteSubjectCategoryForm>({
            deletionReason: new FormControl(null, [Validators.required]),
            description: new FormControl(null, [Validators.maxLength(MAX_DESCRIPTION_LENGTH)]),
        });
        this.form.controls.deletionReason.valueChanges.subscribe(value => {
            if (value === DeletedBaseType.OTHER) {
                this.form.controls.description.setValidators([
                    Validators.required,
                    Validators.maxLength(MAX_DESCRIPTION_LENGTH),
                ]);
            } else {
                this.form.controls.description.setValidators([Validators.maxLength(MAX_DESCRIPTION_LENGTH)]);
            }
            this.form.controls.description.updateValueAndValidity({emitEvent: false});
        });
    }

    confirm(): void {
        if (this.form.invalid) {
            return;
        }
        const value = this.form.getRawValue();
        this.dialogRef.close({
            deletionReason: value.deletionReason,
            description: value.description,
        });
    }
}

export interface DeleteSubjectCategoryDialogData {
    category: SubjectCategory;
    categoryName: string;
    subjectType: SubjectType;
    identificationNumber: string;
}

export interface DeleteSubjectCategoryDialogResult {
    deletionReason: DeletedBaseType;
    description: string | null;
}

interface DeleteSubjectCategoryForm {
    deletionReason: FormControl<DeletedBaseType>;
    description: FormControl<string>;
}
